export const MAIL_SUBJECT = "Message from ";
